import { useEffect, useRef } from 'react';

export const useAbortSignal = () => {
  const abortController = useRef<AbortController>(new AbortController());

  useEffect(() => {
    abortController.current = new AbortController();

    return () => {
      abortController.current.abort();
    };
  }, []);

  return { signal: abortController.current.signal };
};
